/**
 * Grows a textarea with its content, never shrinking below its initial `rows` height.
 * Bind it directly on the `<textarea>`; `x-model` and `wire:model` keep working natively.
 *
 * @param {{ initialHeight: number }} config Initial height in rem.
 */
export default function autoResizeTextarea({ initialHeight }) {
    const minHeight = `${initialHeight}rem`;
    let observer = null;

    return {
        init() {
            this.$el.style.height = minHeight;

            observer = new ResizeObserver(() => this.resize());
            observer.observe(this.$el);
        },

        destroy() {
            observer?.disconnect();
        },

        resize() {
            this.$el.style.height = 'auto';

            const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const fitsInitialHeight = this.$el.scrollHeight < rootFontSize * initialHeight;

            this.$el.style.height = fitsInitialHeight ? minHeight : `${this.$el.scrollHeight}px`;
        },
    };
}
